import { useContext } from "react";

import { useParams } from "react-router-dom";

import { CurrentPatientContext } from "utils/contexts";
import { translateTreatment } from "utils/translations";

import { TreatmentEditor } from "./components";
import type { Patient, TreatmentEditorSettings } from "./components/TreatmentEditor/types";

interface Props {
  editorSettings: TreatmentEditorSettings;
}

export const Treatment: React.FC<Props> = ({ editorSettings: { context, mode } }) => {
  const params = useParams();
  const { patient: currentPatient, refreshPatient } = useContext(CurrentPatientContext);

  const patient: Patient | undefined = currentPatient
    ? {
        currentWeek: currentPatient?.week,
        id: currentPatient?.id,
        name: `${currentPatient?.first_name} ${currentPatient?.last_name}`,
        location: currentPatient?.most_painful_location?.location,
        treatment: translateTreatment({
          ailment: currentPatient?.ailment,
          lateral_location: currentPatient?.most_painful_location?.lateral_location,
          location: currentPatient?.most_painful_location?.location,
        }),
        // TODO: Fix when typing patient context
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        treatmentID: currentPatient?.treatments.find((treatment: any) => treatment.is_current_treatment === true).id,
        onRefreshPatient: refreshPatient,
        ailment: currentPatient?.ailment,
      }
    : undefined;

  return (
    <TreatmentEditor
      editorSettings={{ context, mode }}
      patient={patient}
      treatmentScheduleID={Number(params.templateID)}
    />
  );
};
